module.exports = __webpack_public_path__ + "static/media/2015-v Pai.dbfe528e.jpg";